import * as React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Grid from "@material-ui/core/Grid";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { localizations } from '../localization/localization'
import { RouteName } from "../routeNames";

interface NavMenuProps {
  history: any;
  userLoggedIn: boolean,
  userRole: string
}

class NavMenu extends React.Component<NavMenuProps & RouteComponentProps<any>, {}>  {

  constructor(props: any) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  public render() {
    const { history, userRole } = this.props;
    const index = history.location.pathname.indexOf("/");
    const length = history.location.pathname.length;
    const route = history.location.pathname.substring(index, length);

    return (
      <Grid>
        <Tabs
          variant="scrollable"
          scrollButtons="on"
          value={route}
          onChange={this.handleChange} 
          indicatorColor="primary">
          <Tab label={localizations.map.mapView} value={RouteName.Map} />
          <Tab label={localizations.statistics.statistics} value={RouteName.Statistics} />
          <Tab label={localizations.menus.freeUnits} value={RouteName.Units} />
          <Tab label={localizations.menus.freeTrucks} value={RouteName.Trucks} />
          {userRole === "Administrator" ? (
            <Tab value={RouteName.AdminCompanies} label={localizations.admin.companiesTitle} />
          ) : null}
          {userRole === "Administrator" ? (
            <Tab value="/admin/feedback" label={localizations.admin.feedbackTitle} />
          ) : null}

        </Tabs>
      </Grid>
    );
  }

  private handleChange(event: any, value: any) {
    this.props.history.push(value);
  }
}

export default withRouter((NavMenu));



// WEBPACK FOOTER //
// ./src/common/NavMenu.tsx